import { render, staticRenderFns } from "./BookFarmTable.vue?vue&type=template&id=5c69df0f&scoped=true&"
import script from "./BookFarmTable.vue?vue&type=script&lang=js&"
export * from "./BookFarmTable.vue?vue&type=script&lang=js&"
import style0 from "./BookFarmTable.vue?vue&type=style&index=0&id=5c69df0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c69df0f",
  null
  
)

export default component.exports